<!-- @format -->
<image-tag>
    <input id="img-upload" type="file" accept='image/*' onchange="{preview}" class="text_input def-hidden">
    <div id="preview-area" class="def-hidden">
        <canvas id="preview" class="canvas-size"></canvas>
        <ul class="file_list" if={filename !== ''}>
            <li class="file_list-item">{ filename }
            <span 
                class="file_list-item_close js-close" 
                onclick="{remove}"
                ></span>
            </li> 
        </ul>
    </div>
    
    <!--何もファイルがアップされていない状態　ここから-->
    <div class="empty" if={filename === ''}>
        <p class="empty-message">アップロードされているファイルはありません。</p>
    </div>

    <script>
    import debounce from 'debounce-promise';
    import basicInformation from "@model/basicInformation/api";

    export default {
        basicInformation: basicInformation,
        fileReader: new FileReader(),
        filename:'',
        preview(e) {
            e.preventDefault() 
            const file = e.target.files[0]       
            const type = file.type.split('/')
            if ('image' != type[0]) {
                return
            }
            if ('jpeg' != type[1] && 'png' != type[1] && 'gif' != type[1]) {
                return
            }
            this.$('#preview-area').classList.remove('def-hidden')
            this.filename = file.name
            this.basicInformation[this.props.name] = file
            this.fileReader.readAsDataURL(file)

            this.remove_valid(this.$('#img-upload'))
            this.update()
            this.showPreview()       
        },
        showPreview(){
            this.fileReader.onload = (()=> {
                let canvas = this.$('#preview')
                let ctx = canvas.getContext('2d')
                let image = new Image();

                image.src = this.fileReader.result;
                image.onload = (() => {
                    canvas.width = image.width;
                    canvas.height = image.height;
                    ctx.drawImage(image, 0, 0);
                })
            })
        },
        remove(e) {
            e.preventDefault()
            this.filename = '' 
            this.basicInformation[this.props.name] = ''
            this.$('#img-upload').value = ''
            this.$('#preview-area').classList.add('def-hidden')
            this.update()
        },
        listenerUploadImg() {
            this.$('#img-upload').click()
        },
        onMounted(props, state) {
            this.basicInformation.on('upload-img_'+ props.name, this.listenerUploadImg)
        },
        onUnmounted(props, state) {
            this.basicInformation.off('upload-img_'+ props.name, this.listenerUploadImg)
        },
        remove_valid(item) {
            item.classList.remove('is-error')
            if (null !== item.parentElement) {
                let errors = item.parentElement.getElementsByClassName('error')
                for (let error of errors) {
                    item.parentElement.removeChild(error)
                }
            }
        }
    }
    </script>
    <style>
        .canvas-size {
            max-width: 500px;
            margin-top: 12px;
        }
        .def-hidden {
            display: none;
        }
    </style>
</image-tag>